import injectSheet from 'react-jss';

import Tooltip from './component';
import styles from './styles';

export default injectSheet(styles)(Tooltip);
